<script setup lang="ts">
/** Сердечко «в избранное» в углу плитки. Анимацию задаёт родитель — он же знает исход запроса. */
withDefaults(
  defineProps<{
    active?: boolean;
    animation?: 'add' | 'remove' | null;
    /** Поверх фото нужен контрастный фон под иконкой. */
    onDark?: boolean;
  }>(),
  { active: false, animation: null, onDark: false },
);

defineEmits<{ (event: 'click', payload: MouseEvent): void }>();
</script>

<template>
  <button
    type="button"
    class="pcard-fav"
    :class="{
      'pcard-fav--on-dark': onDark,
      'is-animating-add': animation === 'add',
      'is-animating-remove': animation === 'remove',
    }"
    :aria-label="active ? 'Убрать из избранного' : 'В избранное'"
    @click.stop="$emit('click', $event)"
  >
    <!--
      Залитое сердце рисуется штрихом в момент добавления в избранное.
      Пустое остаётся обычной иконкой: в каталоге сотня карточек, и сотня
      одновременно прорисовывающихся контуров при загрузке — рябь, а не акцент
      (та же причина, что у «плюса» в ProductCardAction).
    -->
    <Icon
      v-if="active"
      key="fav-on"
      mode="svg"
      name="line-md:heart-filled"
      class="w-7 h-7 text-red-800"
    />
    <UIcon
      v-else
      name="i-heroicons-heart-20-solid"
      class="w-7 h-7 text-red-300"
    />
  </button>
</template>

<style scoped lang="scss">
.pcard-fav {
  @apply flex items-center justify-center;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &--on-dark {
    @apply w-9 h-9 rounded-full backdrop-blur-sm;
    background: rgb(0 0 0 / 0.35);
  }

  &.is-animating-add {
    animation: pcard-fav-pop 0.7s ease;
  }

  &.is-animating-remove {
    animation: pcard-fav-fade 0.7s ease;
  }
}

@keyframes pcard-fav-pop {
  0% { transform: scale(1); }
  35% { transform: scale(1.35); }
  60% { transform: scale(0.92); }
  100% { transform: scale(1); }
}

@keyframes pcard-fav-fade {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.8); opacity: 0.5; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
